export default "__VITE_ASSET__C7OB0n6x__"